import { render, staticRenderFns } from "./HomeGalleriesComponent.vue?vue&type=template&id=c4380a8a"
import script from "./HomeGalleriesComponent.vue?vue&type=script&lang=js"
export * from "./HomeGalleriesComponent.vue?vue&type=script&lang=js"
import style0 from "./HomeGalleriesComponent.vue?vue&type=style&index=0&id=c4380a8a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports